import { ColumnDef } from '@tanstack/react-table';
import { LegacyColumns } from '../types';
import { type CleosTableFeaturesType } from '../tableFeatures';

export const adaptLegacyColumns = <TData extends object>(
  columns: LegacyColumns
): ColumnDef<CleosTableFeaturesType, TData>[] =>
  Object.entries(columns).map(([key, config]) => ({
    id: key,
    // Dotted keys are flat string keys from flattenObjectInArray — use accessorFn to avoid
    // TanStack's nested-access interpretation of dots in accessorKey.
    ...(key.includes('.')
      ? { accessorFn: (row: TData) => (row as Record<string, unknown>)[key] }
      : { accessorKey: key }),
    header: config.text,
    enableSorting: config.sortable ?? false,
    meta: { ...config, columnKey: key },
    cell: (ctx) => ctx.getValue(),
  }));
